import { NCR } from "./actions";
import initialState from "../../../../reducers/initialState";

const NcrReducer = (state = initialState, action) => {
  switch (action.type) {
    case NCR.UPDATE_TOTAL_LIST: {
      return {
        ...state,
        ncrList: action.ncrList,
      };
    }

    case NCR.UPDATE_PENDING_LIST: {
      return {
        ...state,
        pendingNcr: action.pendingNcr,
      };
    }

    default:
      return state;
  }
};

export default NcrReducer;
